var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('input-radio',_vm._b({attrs:{"options":_vm.options,"label":"Enviar para:"},model:{value:(_vm.selectUsers),callback:function ($$v) {_vm.selectUsers=$$v},expression:"selectUsers"}},'input-radio',_vm.$attrs,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }